import React from 'react';
import styles from './styles/styles.module.scss';

export default function CardName({ name, className, paddingRight }) {
  return (
    <div className={`xlate-none ${styles.name} ${className}`} itemProp="name" title={name} style={{ paddingRight: paddingRight || 0 }}>
      {name}
    </div>
  );
}
